module.exports = __webpack_public_path__ + "static/media/close_red.b59087c3.svg";